const TITLE = '';

export default {

  CURRENT_ACCOUNT_HOST_NAME: 'https://stage-api.gamize.com/GamificationAdminService',
  CURRENT_GAMIFICATION_HOST_NAME: 'https://stage-api.gamize.com/GamificationService',
  GAMIFICATION_CAMPAIGN_HOST_NAME: 'https://stage-api.gamize.com/GamificationCampaignService',
  GAMIFICATION_OFFER_HOST_NAME: 'https://stage-api.gamize.com/gamificationOfferIntegration',
  GAMIFICATION_USER_SERVICE_HOST_NAME: 'https://stage-api.gamize.com/GamificationUserService',

  LOGIN: `${TITLE} Login`,
  SIGNUP: `${TITLE} Sign up`,
  RESET_PASSWORD: `${TITLE} Reset password`,
  BASE_URL: process.env.PUBLIC_URL,
  PAGE_SIZE: 5,
  ITEM_PER_PAGE_5: 5,
  ITEM_PER_PAGE_10: 10,
  ORDER_ASC: 'asc',
  ORDER_DESC: 'desc',
  INTERVAL_TIME: 600000,
  HOST_TYPE: 'localhost',
  BROWSER: 'Browser',
  ERROR: 'ERROR',
  STUDENT: 'Student',
};
